var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewElectricityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new-elec",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M0,0H32V32H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M14.5,18.374c-2.319.007-4.56.018-6.8.015-.519,0-1.124.154-1.438-.42-.3-.547.182-.9.458-1.271Q12.344,9.023,17.982,1.357c.069-.094.141-.187.208-.284a.8.8,0,0,1,.977-.417c.449.157.377.519.3.872q-1.058,5.258-2.1,10.52a2.222,2.222,0,0,0,0,.259h.654l6.669-.018c.451,0,.97,0,1.1.446a1.338,1.338,0,0,1-.188,1.034q-5.951,8.567-11.951,17.107c-.078.115-.144.262-.262.313-.239.1-.559.261-.753.186a.734.734,0,0,1-.353-.621c.1-.885.281-1.764.441-2.643.584-3.218,1.171-6.436,1.773-9.731",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewElectricityLogo);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0ibmV3LWVsZWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogIDxnIGlkPSJHcm91cF8zNjQ4IiBkYXRhLW5hbWU9Ikdyb3VwIDM2NDgiPgogICAgPGcgaWQ9Ikdyb3VwXzM2NDciIGRhdGEtbmFtZT0iR3JvdXAgMzY0NyI+CiAgICAgIDxnIGlkPSJHcm91cF8zNjQ2IiBkYXRhLW5hbWU9Ikdyb3VwIDM2NDYiPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzIxOTMiIGRhdGEtbmFtZT0iUGF0aCAyMTkzIiBkPSJNMCwwSDMyVjMySDBaIiBmaWxsPSJub25lIi8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMjE5NCIgZGF0YS1uYW1lPSJQYXRoIDIxOTQiIGQ9Ik0xNC41LDE4LjM3NGMtMi4zMTkuMDA3LTQuNTYuMDE4LTYuOC4wMTUtLjUxOSwwLTEuMTI0LjE1NC0xLjQzOC0uNDItLjMtLjU0Ny4xODItLjkuNDU4LTEuMjcxUTEyLjM0NCw5LjAyMywxNy45ODIsMS4zNTdjLjA2OS0uMDk0LjE0MS0uMTg3LjIwOC0uMjg0YS44LjgsMCwwLDEsLjk3Ny0uNDE3Yy40NDkuMTU3LjM3Ny41MTkuMy44NzJxLTEuMDU4LDUuMjU4LTIuMSwxMC41MmEyLjIyMiwyLjIyMiwwLDAsMCwwLC4yNTloLjY1NGw2LjY2OS0uMDE4Yy40NTEsMCwuOTcsMCwxLjEuNDQ2YTEuMzM4LDEuMzM4LDAsMCwxLS4xODgsMS4wMzRxLTUuOTUxLDguNTY3LTExLjk1MSwxNy4xMDdjLS4wNzguMTE1LS4xNDQuMjYyLS4yNjIuMzEzLS4yMzkuMS0uNTU5LjI2MS0uNzUzLjE4NmEuNzM0LjczNCwwLDAsMS0uMzUzLS42MjFjLjEtLjg4NS4yODEtMS43NjQuNDQxLTIuNjQzLjU4NC0zLjIxOCwxLjE3MS02LjQzNiwxLjc3My05LjczMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0iI2ZmZiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };